import actions from "./actions";
import mutations from "./mutations";

const state = {
  res_pinjaman: [],
  noa: null,
  filter: false,
  nospp: null,
  res_mutasiPinjaman: [],
  data_pinjam: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
